import styled from '@emotion/styled';
import type { Prismic } from '@landsbankinn/prismic';
import { device } from '@landsbankinn/ui';
import React from 'react';

import { Img } from '../../components/img/Img';

const Host = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 36px;

  @media ${device.tablet} {
    align-items: center;
    flex-flow: column nowrap;
    margin-bottom: 50px;
  }
`;

const Image = styled.div`
  width: 50px;
  height: 50px;
  margin-right: 20px;
  flex-shrink: 0;

  img {
    border-radius: 50%;
  }

  @media ${device.tablet} {
    width: 100%;
    height: auto;
    max-width: 171px;
    margin-bottom: 26px;
    margin-right: 0;
  }
`;

const Content = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;

  @media ${device.tablet} {
    flex-flow: column nowrap;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
  }
`;

const Name = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;
const Title = styled.div`
  font-size: 14px;
  line-height: 20px;
`;

interface IAuthor {
  image: Prismic.Image;
  name: string | null;
  title: string | null;
}

export const Author = ({ image, name, title }: IAuthor) => {
  return (
    <Host>
      <Image>
        <Img src={image} percentage={0.2} ar="ar_1_1" aspectRatio={1 / 1} />
      </Image>
      <Content>
        <Name>{name}</Name>
        <Title>{title}</Title>
      </Content>
    </Host>
  );
};
